// Hinglish & English translations for the diagnostic funnel.
// Keep this file as the single source of all copy.

export const translations = {
  hinglish: {
    languageToggle: { en: "English", hi: "Hinglish" },
    common: {
      back: "Back",
      continue: "Continue",
      restart: "Restart Diagnostic",
      stepOf: (a, b) => `Step ${a} of ${b}`,
      builtFor:
        "Built for real estate sales partners, brokers, channel partners and consultants.",
      yourAnswerSaved: "Saved",
      multipleSelectHint: "Multiple select allowed",
      selectOne: "Select one option",
    },
    intro: {
      heading:
        "Aapke buyer enquiries actual site visits mein convert ho rahe hain?",
      sub: "2 minute ka quick diagnostic complete karo aur dekho ki buyer journey mein leakage qualification, project matching, site visit confidence ya follow-up mein hai.",
      namePlaceholder: "Aapka naam (optional)",
      nameLabel: "Pehle aapka naam",
      start: "Start Diagnostic",
    },
    s2: {
      question:
        "Kya aap currently real estate properties sell ya promote karte ho?",
      options: [
        { value: "yes", label: "Yes, actively karta hoon" },
        { value: "no", label: "Not right now" },
      ],
    },
    exit: {
      heading:
        "ChannelPartner.Network active real estate sales partners ke liye bana hai.",
      text: "Jab aap real estate enquiries ko better qualify karna, suitable projects match karna aur focused site visits improve karna chahenge, tab ChannelPartner.Network useful rahega.",
      cta: "Visit ChannelPartner.Network",
    },
    s3: {
      question: "Aap real estate sales mein kis role mein kaam karte ho?",
      options: [
        { value: "channel_partner", label: "Channel Partner / Broker" },
        { value: "freelancer", label: "Freelance Real Estate Sales Partner" },
        { value: "developer_sales", label: "Developer Sales Partner" },
        { value: "consultant", label: "Real Estate Consultant" },
        { value: "other", label: "Other" },
      ],
    },
    s4: {
      question: "Aap kis type ki properties sell karte ho?",
      hint: "Multiple select allowed",
      options: [
        { value: "residential", label: "Residential" },
        { value: "commercial", label: "Commercial" },
        { value: "plots", label: "Plots / Land" },
        { value: "multiple", label: "Multiple property types" },
      ],
    },
    s5: {
      question: "Aapko usually buyer enquiries kahan se milti hain?",
      hint: "Multiple select allowed",
      options: [
        { value: "references", label: "References" },
        { value: "digital", label: "Digital Marketing" },
        { value: "whatsapp", label: "WhatsApp / Social Media" },
        { value: "walkins", label: "Walk-ins" },
        { value: "events", label: "Exhibitions / Events" },
        { value: "developer_leads", label: "Developer Leads" },
        { value: "broker_network", label: "Broker Network" },
        { value: "other", label: "Other" },
      ],
    },
    s6: {
      question:
        "Enquiry aane ke baad buyer journey mein sabse bada leakage kahan hota hai?",
      cta: "Show My Diagnosis",
      options: [
        {
          value: "qualification",
          label: "Buyer ko phone par qualify karna mushkil hota hai",
        },
        {
          value: "matching",
          label: "Buyer ke liye suitable project dhundhne mein time lagta hai",
        },
        {
          value: "visit_confidence",
          label: "Buyer site visit ke liye easily agree nahi karta",
        },
        {
          value: "interest_to_visit",
          label: "Buyer interested hota hai but visit nahi karta",
        },
        {
          value: "comparison",
          label: "Buyer bahut options compare karke confuse ho jata hai",
        },
        {
          value: "followup",
          label: "Follow-up ke baad buyer ka interest drop ho jata hai",
        },
        {
          value: "lead_identity",
          label: "Lead protection / tagging ka concern hota hai",
        },
      ],
    },
    diagnoses: {
      qualification: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Qualification Gap",
        heading:
          "Aapka time un buyers par ja raha hai jo pehle se properly qualified nahi hain.",
        text: "Har enquiry par long phone call karna scalable nahi hota. Agar buyer pehle project explore kare, compare kare aur interest show kare, toh aapki first serious conversation much better ho sakti hai.",
        solution:
          "ChannelPartner.Network se aap suitable project journeys share kar sakte ho jahan buyer call se pehle project samajh sakta hai, interest show kar sakta hai, aur better qualified discussion ke liye ready hota hai.",
        benefit:
          "Less random calling. Better qualified buyers. Better conversations.",
      },
      matching: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Project Matching Gap",
        heading:
          "Buyer ke liye right project quickly match karna aapka bottleneck ban raha hai.",
        text: "Buyer ka budget, location, property type aur requirement samajhkar manually projects dhundhna slow process hai. Is delay mein buyer ka interest drop ho sakta hai.",
        solution:
          "ChannelPartner.Network aapko structured project sharing aur matchmaking journey create karne mein help karta hai, so that every buyer gets a more suitable project experience.",
        benefit:
          "Faster matching. Better presentation. More buyer confidence.",
      },
      visit_confidence: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Site Visit Confidence Gap",
        heading: "Buyer site visit tabhi karega jab usko pehle clarity milegi.",
        text: "Bina clarity ke buyer apna time site visit mein invest nahi karta. Usko pehle project, location, amenities, lifestyle fit, budget aur key highlights samajhne hote hain.",
        solution:
          "ChannelPartner.Network ka pre-site visit matchmaking buyer ko visit se pehle project samjhaata hai, so that site visit blind visit nahi, confident decision ban sake.",
        benefit: "Better informed buyers. More focused site visits.",
      },
      interest_to_visit: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Interest-to-Visit Gap",
        heading:
          "Interest ko actual site visit mein convert karna sabse important step hai.",
        text: "Buyer interested bolta hai, but agar usko project ka strong reason nahi dikhta, toh visit postpone hoti rehti hai ya drop ho jaati hai.",
        solution:
          "ChannelPartner.Network buyer ko pre-site visit project understanding deta hai, so that buyer ko clear ho ki project worth visiting hai ya nahi.",
        benefit: "Less casual interest. More serious visits.",
      },
      comparison: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Comparison Confusion Gap",
        heading:
          "Too many options buyer ko decision ke closer nahi, confusion ke closer le jaate hain.",
        text: "WhatsApp messages, PDFs, brochures aur random links se buyer ka comparison structured nahi hota. Isse buyer delay karta hai ya decision avoid karta hai.",
        solution:
          "ChannelPartner.Network buyer ko guided way mein projects explore aur compare karne mein help karta hai, making the decision journey clearer and more professional.",
        benefit:
          "Clear comparison. Faster decision-making. Better follow-up.",
      },
      followup: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Follow-up Recall Gap",
        heading: "Ek phone call ke baad buyer sab kuch yaad nahi rakhta.",
        text: "Buyer aur uski family ko project details baad mein revisit karni hoti hain. Agar presentation strong nahi hai, toh interest naturally drop hota hai.",
        solution:
          "ChannelPartner.Network se aap interactive project journeys share kar sakte ho, jise buyer aur family baad mein bhi revisit, discuss aur act upon kar sakti hai.",
        benefit:
          "Better recall. Better family discussion. Better follow-up quality.",
      },
      lead_identity: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Lead Identity Gap",
        heading:
          "Aapke buyer journey ke saath aapki identity connected rehni chahiye.",
        text: "Real estate sales mein lead identity aur protection ka concern genuine hota hai. Agar buyer journey structured nahi hai, toh tracking weak ho sakti hai.",
        solution:
          "ChannelPartner.Network buyer journey ko channel partner identity ke saath connect karne mein help karta hai through QR-based site visit flow and soft tagging support.",
        benefit:
          "Better tracking. Better lead confidence. More professional process.",
      },
    },
    s8: {
      heading:
        "Ab imagine karo, agar har serious buyer enquiry ke saath yeh system ho.",
      text: "ChannelPartner.Network real estate sales partners ko help karta hai enquiries pre-qualify karne mein, suitable projects professionally share karne mein, buyer ko site visit se pehle project samjhaane mein, aur better-matched buyers ko focused site visits tak le jaane mein.",
      benefits: [
        "Pre-qualify buyers before long calls",
        "Share suitable projects faster",
        "Improve buyer confidence before site visit",
        "Reduce random and unproductive visits",
        "Increase focused site visits",
        "Support lead identity with QR and soft tagging flow",
        "Improve conversion chances with matchmaking-led buyer journeys",
      ],
      question: "Kya aap aise network ka part banna chahenge?",
      options: [
        { value: "yes", label: "Yes, mujhe join karna hai" },
        { value: "no", label: "Not right now" },
      ],
    },
    finalSignup: {
      heading: "Join ChannelPartner.Network",
      text: "Start using a structured matchmaking system built for real estate sales partners who want better buyer qualification, better project matching, and more focused site visits.",
      cta: "Sign Up Now",
      notNow: "Not now",
    },
    softExit: {
      heading: "No problem.",
      text: "Jab aap buyer enquiries ko more professionally handle karna, suitable projects faster match karna, aur focused site visits improve karna chahenge, ChannelPartner.Network aapke liye useful rahega.",
      cta: "Visit ChannelPartner.Network",
      restart: "Restart Diagnostic",
    },
  },

  english: {
    languageToggle: { en: "English", hi: "Hinglish" },
    common: {
      back: "Back",
      continue: "Continue",
      restart: "Restart Diagnostic",
      stepOf: (a, b) => `Step ${a} of ${b}`,
      builtFor:
        "Built for real estate sales partners, brokers, channel partners and consultants.",
      yourAnswerSaved: "Saved",
      multipleSelectHint: "Multiple select allowed",
      selectOne: "Select one option",
    },
    intro: {
      heading:
        "Are your buyer enquiries converting into actual site visits?",
      sub: "Complete this quick 2-minute diagnostic and see where your buyer journey is leaking — qualification, project matching, site visit confidence, follow-up, or lead protection.",
      namePlaceholder: "Your name (optional)",
      nameLabel: "First, your name",
      start: "Start Diagnostic",
    },
    s2: {
      question: "Are you currently selling or promoting real estate properties?",
      options: [
        { value: "yes", label: "Yes, actively selling" },
        { value: "no", label: "Not right now" },
      ],
    },
    exit: {
      heading:
        "ChannelPartner.Network is built for active real estate sales partners.",
      text: "Whenever you want to better qualify enquiries, match suitable projects, and improve focused site visits — ChannelPartner.Network will be useful.",
      cta: "Visit ChannelPartner.Network",
    },
    s3: {
      question: "What role do you play in real estate sales?",
      options: [
        { value: "channel_partner", label: "Channel Partner / Broker" },
        { value: "freelancer", label: "Freelance Real Estate Sales Partner" },
        { value: "developer_sales", label: "Developer Sales Partner" },
        { value: "consultant", label: "Real Estate Consultant" },
        { value: "other", label: "Other" },
      ],
    },
    s4: {
      question: "What type of properties do you sell?",
      hint: "Multiple select allowed",
      options: [
        { value: "residential", label: "Residential" },
        { value: "commercial", label: "Commercial" },
        { value: "plots", label: "Plots / Land" },
        { value: "multiple", label: "Multiple property types" },
      ],
    },
    s5: {
      question: "Where do you usually get buyer enquiries from?",
      hint: "Multiple select allowed",
      options: [
        { value: "references", label: "References" },
        { value: "digital", label: "Digital Marketing" },
        { value: "whatsapp", label: "WhatsApp / Social Media" },
        { value: "walkins", label: "Walk-ins" },
        { value: "events", label: "Exhibitions / Events" },
        { value: "developer_leads", label: "Developer Leads" },
        { value: "broker_network", label: "Broker Network" },
        { value: "other", label: "Other" },
      ],
    },
    s6: {
      question:
        "After receiving an enquiry, where does the buyer journey usually get stuck?",
      cta: "Show My Diagnosis",
      options: [
        {
          value: "qualification",
          label: "Qualifying the buyer on phone calls is difficult",
        },
        {
          value: "matching",
          label: "Finding suitable projects takes time",
        },
        {
          value: "visit_confidence",
          label: "Buyer does not easily agree for site visits",
        },
        {
          value: "interest_to_visit",
          label: "Buyer shows interest but does not visit",
        },
        {
          value: "comparison",
          label: "Buyer gets confused while comparing too many options",
        },
        {
          value: "followup",
          label: "Buyer interest drops after follow-up",
        },
        {
          value: "lead_identity",
          label: "Lead protection / tagging is a concern",
        },
      ],
    },
    diagnoses: {
      qualification: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Qualification Gap",
        heading:
          "Your time is going into buyers who aren't properly qualified yet.",
        text: "Long phone calls on every enquiry don't scale. If the buyer first explores the project, compares, and shows interest, your first serious conversation becomes much better.",
        solution:
          "With ChannelPartner.Network, you can share suitable project journeys where the buyer understands the project before the call, shows interest, and is ready for a better qualified discussion.",
        benefit:
          "Less random calling. Better qualified buyers. Better conversations.",
      },
      matching: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Project Matching Gap",
        heading:
          "Quickly matching the right project to a buyer is becoming your bottleneck.",
        text: "Manually finding projects that match the buyer's budget, location, property type and requirements is a slow process. Buyer interest can drop in that delay.",
        solution:
          "ChannelPartner.Network helps you create structured project sharing and matchmaking journeys, so every buyer gets a more suitable project experience.",
        benefit:
          "Faster matching. Better presentation. More buyer confidence.",
      },
      visit_confidence: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Site Visit Confidence Gap",
        heading: "A buyer will only visit when they have clarity first.",
        text: "Without clarity, buyers don't invest time in a site visit. They first need to understand the project, location, amenities, lifestyle fit, budget and key highlights.",
        solution:
          "ChannelPartner.Network's pre-site visit matchmaking helps buyers understand the project before they visit, so the site visit isn't blind — it becomes a confident decision.",
        benefit: "Better informed buyers. More focused site visits.",
      },
      interest_to_visit: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Interest-to-Visit Gap",
        heading:
          "Converting interest into an actual site visit is the most important step.",
        text: "Buyers say they're interested, but without a strong reason to act, the visit keeps getting postponed or eventually drops off.",
        solution:
          "ChannelPartner.Network gives the buyer a pre-site-visit project understanding, so they're clear on whether the project is worth visiting.",
        benefit: "Less casual interest. More serious visits.",
      },
      comparison: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Comparison Confusion Gap",
        heading:
          "Too many options push buyers closer to confusion, not closer to a decision.",
        text: "WhatsApp messages, PDFs, brochures and random links make comparisons unstructured. Buyers delay or avoid the decision.",
        solution:
          "ChannelPartner.Network helps buyers explore and compare projects in a guided way, making the decision journey clearer and more professional.",
        benefit:
          "Clear comparison. Faster decision-making. Better follow-up.",
      },
      followup: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Follow-up Recall Gap",
        heading: "After one phone call, buyers don't remember everything.",
        text: "Buyers and their families need to revisit project details later. If the presentation isn't strong, interest naturally drops.",
        solution:
          "With ChannelPartner.Network, you share interactive project journeys that the buyer and family can revisit, discuss and act upon later.",
        benefit:
          "Better recall. Better family discussion. Better follow-up quality.",
      },
      lead_identity: {
        leakageLabel: "Your Buyer Journey Leakage:",
        leakageName: "Lead Identity Gap",
        heading:
          "Your identity should stay connected to your buyer's journey.",
        text: "Lead identity and protection are genuine concerns in real estate sales. If the buyer journey isn't structured, tracking becomes weak.",
        solution:
          "ChannelPartner.Network helps connect the buyer journey with channel partner identity through QR-based site visit flow and soft tagging support.",
        benefit:
          "Better tracking. Better lead confidence. More professional process.",
      },
    },
    s8: {
      heading:
        "Now imagine — every serious buyer enquiry running through this system.",
      text: "ChannelPartner.Network helps real estate sales partners pre-qualify enquiries, share suitable projects professionally, prepare buyers before the site visit, and move better-matched buyers to focused site visits.",
      benefits: [
        "Pre-qualify buyers before long calls",
        "Share suitable projects faster",
        "Improve buyer confidence before site visit",
        "Reduce random and unproductive visits",
        "Increase focused site visits",
        "Support lead identity with QR and soft tagging flow",
        "Improve conversion chances with matchmaking-led buyer journeys",
      ],
      question: "Would you like to join a network built to solve this?",
      options: [
        { value: "yes", label: "Yes, I want to join" },
        { value: "no", label: "Not right now" },
      ],
    },
    finalSignup: {
      heading: "Join ChannelPartner.Network",
      text: "Start using a structured matchmaking system built for real estate sales partners who want better buyer qualification, better project matching, and more focused site visits.",
      cta: "Sign Up Now",
      notNow: "Not now",
    },
    softExit: {
      heading: "No problem.",
      text: "Whenever you want to handle buyer enquiries more professionally, match suitable projects faster, and improve focused site visits — ChannelPartner.Network will be there for you.",
      cta: "Visit ChannelPartner.Network",
      restart: "Restart Diagnostic",
    },
  },
};
